import { babyface } from '../CDNUrl';

const EVENT_BANNER_URI = `${babyface}/event/event_banner`;
const EVENT_DETAIL_URI = `${babyface}/event_detail`;

export const EVENT_BANNER_REFUND = {
  src: `${EVENT_BANNER_URI}_refund.png`,
  alt: `100% 환불 안심제도 이벤트 배너`,
};

export const EVENT_DETAIL_REFUND = [
  {
    src: `${EVENT_DETAIL_URI}/refund_01.png`,
    alt: `100% 환불 안심제도 이벤트 안내사항`,
  }, {
    src: `${EVENT_DETAIL_URI}/refund_02.png`,
    alt: `100% 환불 안심제도 환불 프로세스`,
  }, {
    src: `${EVENT_DETAIL_URI}/refund_03.png`,
    alt: `100% 환불 안심제도 환불 방법 안내`,
  }      
];